export default {
  date: 'Ng\u00e0y',
  chooseExpDate: 'Ch\u1ecdn ng\u00e0y',
  filterExpDate: 'L\u1ecdc theo ng\u00e0y',
  experienceType: 'Lo\u1ea1i',
  filterExperienceType: 'L\u1ecdc theo lo\u1ea1i',
  experienceVibe: 'Phong c\u00e1ch',
  filterExperienceVibe: 'L\u1ecdc theo phong c\u00e1ch',
  search: 'T\u00ecm ki\u1ebfm',
  viewCalendar: 'L\u1ecbch',
  back: 'Quay l\u1ea1i',
  previous: 'Tr\u01b0\u1edbc',
  next: 'Ti\u1ebfp',
  noExperiences: 'Kh\u00f4ng c\u00f3 tr\u1ea3i nghi\u1ec7m',
  cancelChanges: 'H\u1ee7y thay \u0111\u1ed5i',
  saveChanges: 'L\u01b0u thay \u0111\u1ed5i',
  removeFromReservation: 'X\u00f3a kh\u1ecfi \u0111\u1eb7t ch\u1ed7',
  addToCart: 'Th\u00eam v\u00e0o gi\u1ecf h\u00e0ng',
  proceedToCheckout: 'Ti\u1ebfn h\u00e0nh thanh to\u00e1n',
  selectDate: 'Ch\u1ecdn ng\u00e0y',
  startDate: 'Ng\u00e0y b\u1eaft \u0111\u1ea7u',
  endDate: 'Ng\u00e0y k\u1ebft th\u00fac',
  submit: 'G\u1eedi',
  filterExperienceTypeScreenReader:
    'S\u1eed d\u1ee5ng c\u00e1c b\u1ed9 l\u1ecdc n\u00e0y \u0111\u1ec3 thu h\u1eb9p k\u1ebft qu\u1ea3. N\u1ed9i dung t\u1ef1 \u0111\u1ed9ng c\u1eadp nh\u1eadt khi ch\u1ecdn b\u1ed9 l\u1ecdc.',
};
